import React from "react";
import MDBox from "../../controls/MDBox";
import Grid from "@mui/material/Grid";
import BarChart3DCustom from "./BarChart3DCustom";
import PieChart3DCustom from "./PieChart3DCustom";
import LineChart3DCustom from "./LineChart3DCustom";
import Surface3DCustom from "./Surface3DCustom";

/**
 * Ejemplo de uso de los componentes de gráficos 3D con Plotly.js
 * 
 * Este archivo muestra cómo usar cada uno de los componentes 3D disponibles
 */

const Ejemplos3DGraphs = () => {
  
  // Datos de ejemplo para gráfico de barras 3D
  const dataBarras = [
    { categoria: "Enero", ventas: 45000 },
    { categoria: "Febrero", ventas: 52000 },
    { categoria: "Marzo", ventas: 48000 },
    { categoria: "Abril", ventas: 61000 },
    { categoria: "Mayo", ventas: 55000 },
    { categoria: "Junio", ventas: 67000 },
  ];

  // Datos de ejemplo para gráfico de pastel 3D
  const dataPie = [
    { region: "Norte", cantidad: 2500 },
    { region: "Sur", cantidad: 1800 },
    { region: "Este", cantidad: 3200 },
    { region: "Oeste", cantidad: 2100 },
    { region: "Centro", cantidad: 2800 },
  ];

  // Datos de ejemplo para gráfico de líneas 3D
  const dataLineas = [
    { mes: 1, temperatura: 15, humedad: 65 },
    { mes: 2, temperatura: 18, humedad: 70 },
    { mes: 3, temperatura: 22, humedad: 68 },
    { mes: 4, temperatura: 25, humedad: 62 },
    { mes: 5, temperatura: 28, humedad: 58 },
    { mes: 6, temperatura: 32, humedad: 55 },
    { mes: 7, temperatura: 35, humedad: 52 },
    { mes: 8, temperatura: 34, humedad: 54 },
    { mes: 9, temperatura: 30, humedad: 60 },
    { mes: 10, temperatura: 25, humedad: 64 },
    { mes: 11, temperatura: 20, humedad: 68 },
    { mes: 12, temperatura: 16, humedad: 72 },
  ];

  // Datos de ejemplo para gráfico de superficie 3D
  const dataSurface = [];
  for (let x = -5; x <= 5; x += 0.5) {
    for (let y = -5; y <= 5; y += 0.5) {
      dataSurface.push({
        x: x,
        y: y,
        z: Math.sin(Math.sqrt(x * x + y * y))
      });
    }
  }

  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        
        {/* Gráfico de Barras 3D */}
        <Grid item xs={12} lg={6}>
          <BarChart3DCustom
            data={dataBarras}
            namekey="categoria"
            datakey="ventas"
            title="Ventas Mensuales 3D"
            nameeje="Meses"
            nameejevertical="Ventas ($)"
            observaciones="Datos de ejemplo de ventas mensuales"
          />
        </Grid>

        {/* Gráfico de Pastel 3D */}
        <Grid item xs={12} lg={6}>
          <PieChart3DCustom
            data={dataPie}
            namekey="region"
            datakey="cantidad"
            title="Distribución por Región 3D"
            observaciones="Distribución de ventas por región geográfica"
          />
        </Grid>

        {/* Gráfico de Líneas 3D */}
        <Grid item xs={12} lg={6}>
          <LineChart3DCustom
            data={dataLineas}
            xkey="mes"
            ykey="temperatura"
            zkey="humedad"
            title="Temperatura vs Humedad 3D"
            xlabel="Mes"
            ylabel="Temperatura (°C)"
            zlabel="Humedad (%)"
            observaciones="Relación entre temperatura y humedad mensual"
          />
        </Grid>

        {/* Gráfico de Superficie 3D */}
        <Grid item xs={12} lg={6}>
          <Surface3DCustom
            data={dataSurface}
            xkey="x"
            ykey="y"
            zkey="z"
            title="Superficie Matemática 3D"
            xlabel="X"
            ylabel="Y"
            zlabel="Z = sin(√(x²+y²))"
            observaciones="Visualización de función matemática en 3D"
          />
        </Grid>

      </Grid>
    </MDBox>
  );
};

export default Ejemplos3DGraphs;
